<template>
    <div>
        <router-view></router-view>
        <div class="content-body">
            <div class="widgets">
              <div class="widgets-wrapper">
                <CampaignByMonthWidget title="Envois des campagnes" period="current_year" class-name="full"></CampaignByMonthWidget>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Header from '../../layouts/Header.vue'
    import CampaignByMonthWidget from './campaign/CampaignByMonthWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){

        },
        components: {
            'app-header': Header,
            'CampaignByMonthWidget': CampaignByMonthWidget
        },
        methods: {
            edit: function(id){
                this.$router.push('/person/'+id);
            },
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/Dashboard.vue